module.exports = __webpack_public_path__ + "img/paddle.94ad585d.svg";